export enum CreatedIssuesEnum {
  ALL = 'created-issues.all',
  DRAFT = 'created-issues.draft',
  IN_REVIEW = 'created-issues.open', // Backend field name remains 'open'
  IN_PROGRESS = 'created-issues.in-progress',
  REMEDIATION_PLANNING = 'created-issues.remediation-planning',
  IN_REMEDIATION = 'created-issues.in-remediation',
}

export enum ManagedIssuesEnum {
  ALL = 'managed-issues.all',
  ACTIONS_NOT_INITIATED = 'managed-issues.actions-not-initiated',
  ACTIONS_INITIATED = 'managed-issues.actions-initiated',
  ONGOING = 'managed-issues.ongoing',
  OVERDUE = 'managed-issues.overdue',
  SLA_OVERDUE = 'managed-issues.sla-overdue',
}

export enum IncomingIssuesEnum {
  ALL = 'incoming-issues.all',
  UNASSIGNED = 'incoming-issues.unassigned',
}

export enum OwnedIssuesEnum {
  ALL = 'owned-issues.all',
  ACTIONS_NOT_INITIATED = 'owned-issues.actions-not-initiated',
  ACTIONS_INITIATED = 'owned-issues.actions-initiated',
  ONGOING = 'owned-issues.ongoing',
  OVERDUE = 'owned-issues.overdue',
  TO_BE_APPROVED = 'owned-issues.to-be-approved',
}

export enum OwnedActionsEnum {
  ALL = 'owned-actions.all',
  OPEN = 'owned-actions.open',
  IN_PROGRESS = 'owned-actions.in-progress',
  OVERDUE = 'owned-actions.overdue',
  TO_BE_APPROVED = 'owned-actions.to-be-approved',
  COMPLETED = 'owned-actions.completed',
}

export enum ToBeApprovedEnum {
  ISSUES_TO_APPROVE = 'to-be-approved.issues-to-approve',
  ACTIONS_TO_APPROVE = 'to-be-approved.actions-to-approve',
}

export type QuickFilterAllEnum =
  | CreatedIssuesEnum
  | ManagedIssuesEnum
  | IncomingIssuesEnum
  | OwnedIssuesEnum
  | OwnedActionsEnum
  | ToBeApprovedEnum;
